module.exports = "/cyber/_next/static/images/warning-5c36c079bb50fffc278377393d305441.png";